import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
export function Footer() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const getHref = (hash: string) => isHome ? hash : `/${hash}`;
  return <footer className="bg-[#050505] border-t border-white/5 py-16 relative z-10" data-id="element-277">
      <div className="max-w-7xl mx-auto px-6" data-id="element-278">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10 mb-16" data-id="element-279">
          <div data-id="element-280">
            <Logo className="text-2xl mb-4" dotClassName="w-2 h-2 ml-1" data-id="element-281" />
            <p className="text-sm text-gray-500 font-medium tracking-wide" data-id="element-282">
              Purpose-built AI for real industries.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-x-8 gap-y-4" data-id="element-283">
            <a href={getHref('#solutions')} className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-284">
              Solutions
            </a>
            <a href={getHref('#platform')} className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-285">
              Platform
            </a>
            <a href={getHref('#solutions')} className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-286">
              Industries
            </a>
            <a href={getHref('#about')} className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-287">
              About
            </a>
            <a href={getHref('#contact')} className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-288">
              Contact
            </a>
            <a href="mailto:sales@aijentik.com" className="text-sm font-medium text-brand-orange hover:text-brand-deep-orange transition-colors" data-id="element-289">
              sales@aijentik.com
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/5 text-xs text-gray-600" data-id="element-290">
          <div data-id="element-291">
            © {new Date().getFullYear()} Aijentik. All rights reserved.
          </div>
          <div className="flex items-center gap-6 mt-4 md:mt-0" data-id="element-292">
            <Link to="/privacy-policy" className="hover:text-gray-400 transition-colors" data-id="element-293">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="hover:text-gray-400 transition-colors" data-id="element-294">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}